import { isConsoleOn } from "../Config/config"

export const consolelog = (msg:any, data?:any)=>{
    if(isConsoleOn){
        if(data){
            consolelog(msg,data)
        }else{
            consolelog(msg)
        }
    }
}